import React from 'react';
import PropTypes from 'prop-types';
import unescape from 'lodash/unescape';

import Breadcrumbs from './Breadcrumbs';

const SpotListBreadcrumbs = ({data, ...props}) => {
    const {
        city: {url: cityUrl, displayName},
        activeBreadcrumb: {url, label},
    } = data;

    const items = [
        {
            label: unescape(displayName),
            link: cityUrl,
            isCurrentPage: false,
        },
        {
            label: unescape(label),
            link: url,
            isCurrentPage: true,
        },
    ];

    if (data.categoryBreadcrumb) {
        const {
            label: categoryLabel,
            url: categoryUrl,
        } = data.categoryBreadcrumb;

        items.splice(1, 0, {
            label: unescape(categoryLabel),
            link: categoryUrl,
            isCurrentPage: false,
        });
    }

    return (
        <Breadcrumbs
            items={
                label === 'Current Location'
                    ? [{label: unescape(label), isCurrentPage: true}]
                    : items.filter(Boolean)
            }
            {...props}
        />
    );
};

SpotListBreadcrumbs.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SpotListBreadcrumbs;
